var OCS = OCS || {};
OCS.WxBriefing = OCS.WxBriefing || {};
OCS.WxBriefing.Interfaces = OCS.WxBriefing.Interfaces || {};
OCS.WxBriefing.Functions = OCS.WxBriefing.Functions || {};
OCS.WxBriefing.Functions.define_desktop_horizontal_menu_interface = function () {
    return {
        activate: function (request) {
            OCS.WxBriefing.Functions.get_ui_menu().reset_menu();
            this.parent();
            this.underlay.show();
        },
        deactivate: function () {
            this.parent();
            this.underlay.hide();
        }
    };
};
OCS.WxBriefing.Interfaces.DesktopHorizontalMenu = OCS.WxBriefing.Functions.define_desktop_horizontal_menu_interface();